import { DESKTOP_MEDIA_QUERY } from 'portals-platform-lib';
import styled from 'foundations-theming-specialty/utils';
import { IconButtonWrapper } from './CollapsiblePanelHeader';
export const PanelsContainer = styled.div.withConfig({
  displayName: "CollapsiblePanelStyles__PanelsContainer"
})(["display:flex;flex:1;min-inline-size:0;container-type:inline-size;"]);
const PANEL_MAX_WIDTH = '350px';
const COLLAPSED_PANEL_WIDTH = '80px';
const TABLET_PANEL_MAX_CONTAINER_SHARE = '40cqi';
const DESKTOP_PANEL_MAX_CONTAINER_SHARE = '30cqi';
const getPanelWidth = (isCollapsed, maxContainerShare) => isCollapsed ? COLLAPSED_PANEL_WIDTH : `min(${PANEL_MAX_WIDTH}, ${maxContainerShare})`;
export const PanelWrapper = styled.div.withConfig({
  displayName: "CollapsiblePanelStyles__PanelWrapper"
})(["background-color:", ";color:", ";display:flex;flex-direction:column;height:100%;flex:0 0 ", ";width:", ";min-width:0;@media ", "{flex-basis:", ";width:", ";}", " border-color:", ";transition:width 0.1s ease,flex 0.1s ease;&:hover ", ",&:focus-within ", "{width:", ";opacity:1;transform:translateX(0);margin-inline-end:", ";pointer-events:auto;}"], ({
  theme
}) => theme.color['fill-surface-default'], ({
  theme
}) => theme.color['text-core-default'], ({
  $isCollapsed
}) => getPanelWidth($isCollapsed, TABLET_PANEL_MAX_CONTAINER_SHARE), ({
  $isCollapsed
}) => getPanelWidth($isCollapsed, TABLET_PANEL_MAX_CONTAINER_SHARE), DESKTOP_MEDIA_QUERY, ({
  $isCollapsed
}) => getPanelWidth($isCollapsed, DESKTOP_PANEL_MAX_CONTAINER_SHARE), ({
  $isCollapsed
}) => getPanelWidth($isCollapsed, DESKTOP_PANEL_MAX_CONTAINER_SHARE), ({
  $borderSide
}) => `
    border-inline-${$borderSide}-width: 1px;
    border-inline-${$borderSide}-style: solid;
  `, ({
  theme
}) => theme.color['border-core-disabled'], IconButtonWrapper, IconButtonWrapper, ({
  theme
}) => theme.space['800'], ({
  theme,
  $isCollapsed
}) => $isCollapsed ? '0' : theme.space['200']);
export const ContentWrapper = styled.div.withConfig({
  displayName: "CollapsiblePanelStyles__ContentWrapper"
})(["display:flex;flex-direction:column;gap:", ";flex:1;min-width:0;opacity:", ";transition:opacity 0.3s ease;overflow-x:hidden;overflow-y:auto;padding-inline:", ";padding-block-end:", ";"], ({
  theme
}) => theme.space['500'], ({
  $isCollapsed
}) => $isCollapsed ? '0' : '1', ({
  theme,
  $isCollapsed,
  $flushBody
}) => $flushBody ? '0' : $isCollapsed ? theme.space['600'] : theme.space['500'], ({
  theme,
  $flushBody
}) => $flushBody ? '0' : theme.space['400']);